import { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { api } from "services/api";
import { Header } from "components/Header";
import { ToggleSwitch } from "components/ToggleSwitch";
import { useLocation, useNavigate } from "react-router-dom";
import InputComp from "components/InputComp";
import ButtonComp from "components/Button";
import Layout from "components/Layout";

const headers = [
  {
    label: "Allowed",
    colW: "10ch",
    style: {
      textAlign: "end",
    },
  },

  "Permissions",
];

// const items = [
//   {
//     id: 1,
//     Profiles: "Proﬁles Admin",
//   },
// ];

const PermissionManage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [active, setActive] = useState();

  const [permissionname, setPermissionname] = useState();

  const navigate = useNavigate();
  const location = useLocation();
  const itemData = location.state?.data;
  const navData = location.state;

  const onSelectItm = (data) => {
    console.log("onSelectItm", data?.index);
    console.log("onSelectItm", list[data?.index]?.Allowed);

    setSelectedItem(data);

    const list2 = JSON.parse(JSON.stringify(list || []));
    if (list2 && list2[0] && list2[data?.index]?.Allowed) {
      list2[data?.index].Allowed = {
        label: list2[data?.index]?.Allowed?.label === "Yes" ? "" : "Yes",
        cellStyle: {
          color: "textv2.primary",
          fontWeight: "bold",
        },
      };
      setList([...list2]);
    }
  };

  const onSave = async () => {
    // const data = {};

    setIsLoading(true);

    let permissionitems = [];
    if (list && list[0]) {
      list.forEach((item) => {
        if (item?.Allowed?.label === "Yes") {
          // console.log('fff', item?.data.permvalueid);
          permissionitems.push({
            permissionid: item?.data?.permvalueid,
            permissiontype: item?.data?.permvaluedisp,
            permissionvalue: true,
          });
        }
      });
    }

    let res;
    if (navData.action === "permission-add") {
      res = await api.addPermission({
        permissionname: permissionname,
        active: active,
        permissionitems,
      });
    } else {
      res = await api.updatePermission({
        perm_id: itemData?.permissionid,
        permissionname: permissionname,
        active: active,
        permissionitems,
      });
    }

    setIsLoading(false);
    console.log(res);

    toaster.create({
      title: res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/permissionprofiles", {
        state: {},
      });
    }
  };

  const getPermissionPermissionsList = async () => {
    setIsLoading(true);
    const res = await api.getPermissionPermissionsSelected({
      permissionid: itemData?.permissionid,
    });
    setIsLoading(false);
    if (res?.status === 200) {
      console.log("getPermissionPermissionsList res", res?.data);

      if (res?.data && res?.data[0]) {
        setList(
          res.data.map((item) => ({
            id: item?.permvalueid,
            // State: {
            //   clr: "green",
            //   label: item?.allowed || "",
            // },
            Allowed: {
              label: item?.allowed,
              cellStyle: {
                color: "textv2.primary",
                fontWeight: "bold",
              },
            },
            Permissions: item?.permvaluedisp || "",
            data: item,
          }))
        );
      } else {
        setList([]);
      }
    } else {
      toaster.create({
        title: res?.message,
        type: "error",
      });
    }
  };

  useEffect(() => {
    console.log("useState itemData", itemData);
    setActive(itemData?.active || false);
    getPermissionPermissionsList();
    setPermissionname(itemData?.permissionname || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={
          (navData.action === "permission-add" ? "New " : "") +
          "Permission Profile"
        }
        isLoading={isLoading}
      />
      <Layout type={"f-noscroll"}>
        <InputComp
          label={"Profile"}
          value={permissionname}
          onChange={setPermissionname}
        />
        <TableList
          type={"simple"}
          headers={headers}
          items={list}
          onSelect={onSelectItm}
          selectedItem={selectedItem}
        />
      </Layout>

      {/* <Flex
        direction={"column"}
        alignSelf={"center"}
        overflow={"hidden"}
        gap={"1rem"}
        flex={1}
        alignItems={"center"}
        maxW={"50rem"}
      > */}
      {/* <SimpleGrid columns={1}>
          <InputComp
            label={"Profile"}
            value={permissionname}
            onChange={setPermissionname}
          />
        </SimpleGrid> */}
      {/* </Flex> */}

      <Flex
        justify={"end"}
        // flexFlow={"wrap"}
        gap={"1rem"}
        mt={"1rem"}
        // alignItems={"center"}
      >
        {/* <Field.Root orientation="horizontal" w={"22rem"}> */}
        {/* <Field.Label textStyle={"md"}></Field.Label> */}
        {/* <Input textStyle={"md"} placeholder="Profile Name" /> */}
        {/* </Field.Root> */}
        {/* <InputComp placeholder="Profile Name" /> */}
        {/* <Button variant="outline" onClick={onNew}> */}
        {/* New */}
        {/* </Button> */}
        <ToggleSwitch label={"Active"} value={active} onChange={setActive} />

        {/* <Button bg={"primary"} onClick={onSave} w={"12rem"}>
          Save
        </Button> */}
        <ButtonComp
          label="Save"
          onClick={onSave}
          keyname="save"
          disabled={isLoading}
        />
        {/* <Button variant="outline" onClick={onNew} disabled={!selectedItem}>
            All
          </Button>
          */}
      </Flex>
    </Flex>
  );
};

export default PermissionManage;
